<template>
  <div class="norm-view__table">
    <table>
      <tbody>
        <tr>
          <td>
            {{ $t('Закон') }}
          </td>
          <td>
            {{  norm.law.transName }}
          </td>
        </tr>
        <tr>
          <td>
            {{ $t('Дата принятия') }}
          </td>
          <td>
            <span v-if="norm.law.adoption_date">
              {{  new Date(norm.law.adoption_date) | dateFormat('DD.MM.YYYY') }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            {{ $t('Норма') }}
          </td>
          <td>
            <p>
              {{norm.article ? 'Статья ' + norm.article.number : ''}} {{norm.article_part ? 'ч.' + norm.article_part : ''}}
            </p>
            <p>
              {{  norm.normTextKg }}
            </p>
            <p>
              {{  norm.normText }}
            </p>
            <p>
              <span class="d-block mt-2" v-if="norm.law_changes_required && norm.law_to_change">
                <span class="d-block">Требует внесения изменений в закон:</span>
                <b>{{norm.law_to_change.transName}}</b>
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            {{ $t('Ответственный госорган') }}
          </td>
          <td>
            <p
              v-for="developer in norm.developers"
              class="developer"
            >
              {{ developer.transName }}
              <span
                class="developer-icon"
                v-if="developer.isMain"
              >
                <img
                  src="@/assets/icons/checked.png"
                />
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            {{ $t('Срок реализации') }}
          </td>
          <td>
            <span v-if="norm.implementationPeriod">
              {{  new Date(norm.implementationPeriod) | dateFormat('DD.MM.YYYY') }}
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  export default {
    name: "LawNormViewTable",
    props: {
      norm: {
        type: Object,
        required: true
      }
    }
  }
</script>
<style lang="scss">
 .developer {
    display: flex;
    font-weight: 600;

    &-icon {
      display: block;
      width: 20px;
      margin-left: 10px;

      img {
        width: 100%;
      }
    }
 }
</style>
